export const COMMON_COLORS = {
    primary: "#1648C5",
    secondary: "#2CF0FF",
    white: "#FFFFFF",
    black: "#000000",
    alexxisTextGradientAccent: "#5C73F2",

    successColor: "#4CAF50",
    errorColor: "#F44336",
    allLogColor: "#757575",
    normalLogColor: "#9E9E9E",
    systemError: "#FF5722",
    filteredChat: "#FF9800",

    errorArrow: "#0000FF",
    lightRed: "#FF4C4C",

    // File type colors (don’t change across themes)
    word: "#2B579A",
    excel: "#217346",
    powerpoint: "#D24726",
    pdf: "#F40F02",
    txt: "#4285F4",
    html: "#E34C26",
    css: "#264DE4",
    js: "#F7DF1E",
    json: "#000000",
    image: "#9C27B0",
    audio: "#FF9800",
    video: "#F44336",
    defaultFile: "#607D8B",
    folder: "#FFD700"
};

export const LIGHT_COLORS = {
    backgroundDefault: "rgba(157, 157, 156, 0.4)",
    backgroundPaper: "rgba(157, 157, 156, 0.4)",

    textPrimary: "#212121",
    textSecondary: "#FFFFFF",

    chatEmptyStateTitle: "#052C49",
    userMessageBG: "#F0F0F0",
    containerBG: "#FAFAFA",
    exampleContainer: "#CBD6DB",

    pieChartFaded: "#F9F9F9",
    kpiCardTitle: "#70757A",
    kpiCardValue: "#202124",

    dateTime: "#777777",
    chatHistoryUserMessageBubble: "#E0F7FA",
    chatHistoryAiMessageBubble: "#F1F8E9",
    citationsLabel: "#656565",

    feedbackCardBG: "#F9F9F9",
    feedbackCardHoverBG: "#F0F0F0",

    gridRowHover: "#ECECEC",
    gridRowSelected: "#D0D0D0",
    fileGridHeaderBG: "#F9F9F9",
    fileGridHeaderBorder: "#E0E0E0",
    fileGridBackground: "#FFFFFF",
    fileRowBackground: "#FAFAFA",

    loadingDotInitial: "#FAFAFA",
    loadingDotMiddle: "#ECECEC",
    loadingDotFinal: "#D0D0D0",

    citationBackground: "#E0E0E0",
    citationBackgroundHover: "#D0D0D0",

    actionButtonBackground: "#F9F9F9",
    actionButtonBackgroundHover: "#D0D0D0",

    shortCutKeyBackground: "#ECECEc",
    scrollbarThumb: "#D0D0D0",
    scrollbarTrack: "#FFFFFF",
    drawerMenuBackground: "#FFFFFF",
    cardBackground: "#FFFFFF",
    datagridOverlayBackground: "#FFFFFF",

    primaryButtonIcon: "#FFFFFF",
    primaryIcon: "#000000",
    secondaryIcon: "#4F5F6F",

    borderColor: "rgba(0,0,0,0.12)",
    borderColorHover: "#212121",

    disclaimerText: "#4F5F6F",

    animatedTabBackground: "#F2F2F2",
    animatedTabActiveBackground: "#FFFFFF",
    animatedTabText: "#6E6E6E",
    animatedTabActiveText: "#1A1A1A",
    animatedTabHoverBackground: "transparent",
    animatedTabHoverText: "#1A1A1A",

    dropzoneBackground: "#FFFFFF",
    dropzoneBorder: "rgba(100, 100, 100, 0.4)",
    dropzoneBorderPulse: "rgba(160, 160, 160, 0.6)"
};

export const DARK_COLORS = {
    backgroundDefault: "#35374B",
    backgroundPaper: "#3C3E52",

    textPrimary: "#FFFFFF",
    textSecondary: "#CCCCCC",

    chatEmptyStateTitle: "#9CC9FF",
    userMessageBG: "#44475D",
    containerBG: "#35374B",
    exampleContainer: "#404358",

    pieChartFaded: "#F9F9F9",
    kpiCardTitle: "#A2A7B1",
    kpiCardValue: "#FFFFFF",

    dateTime: "#AEB3BD",
    chatHistoryUserMessageBubble: "#3F435A",
    chatHistoryAiMessageBubble: "#464B63",
    citationsLabel: "#AAAAAA",

    feedbackCardBG: "#44485F",
    feedbackCardHoverBG: "#4E526A",

    gridRowHover: "#404358",
    gridRowSelected: "#4A4D64",
    fileGridHeaderBG: "#404358",
    fileGridHeaderBorder: "#4A4D64",
    fileGridBackground: "#35374B",
    fileRowBackground: "#3C3E52",

    loadingDotInitial: "#3C3F53",
    loadingDotMiddle: "#474A5F",
    loadingDotFinal: "#555A70",

    citationBackground: "#3F4359",
    citationBackgroundHover: "#4A4D66",

    actionButtonBackground: "#404358",
    actionButtonBackgroundHover: "#4F5268",

    shortCutKeyBackground: "#4A4D64",
    scrollbarThumb: "#4F5268",
    scrollbarTrack: "#3C3E52",

    drawerMenuBackground: "#3C3E52",
    cardBackground: "#3C3E52",
    datagridOverlayBackground: "#3C3E52",

    primaryButtonIcon: "#FFFFFF",
    primaryIcon: "#FFFFFF",
    secondaryIcon: "#B8BED1",

    borderColor: "rgba(255, 255, 255, 0.12)",
    borderColorHover: "#4A4D64",

    disclaimerText: "#AAB4C8",

    animatedTabBackground: "#2C2F3C",
    animatedTabActiveBackground: "#3B3F51",
    animatedTabText: "#B0B3C3",
    animatedTabActiveText: "#FFFFFF",
    animatedTabHoverBackground: "transparent",
    animatedTabHoverText: "#FFFFFF",

    dropzoneBackground: "#404358",
    dropzoneBorder: "rgba(255, 255, 255, 0.2)",
    dropzoneBorderPulse: "rgba(255, 255, 255, 0.4)"
};
